import {api} from "../../res/rest/api";
import {request} from "../../res/rest/restRequest";
import {env} from "../../res/config/env";
import {idempiereProcess} from "../../res/rest/process";
import runAuthRequest from "../util/runAuthRequest";
import HttpClient from "../../newStructure/services/http/HttpClient";
import {createAsyncThunk} from "@reduxjs/toolkit";
import Platform from "../../newStructure/logic/platform/platform";
import errorReportRequest from "../../newStructure/services/rest/request/error/errorReportRequest";

const TEMP_BACKEND = "http://localhost:8557";
const URL_RETURN = TEMP_BACKEND + "/redirect";

const reportUnrecognisedPaymentMessage = async (responseData) => {
    void errorReportRequest()
        .tag("Unrecognised Checkout Error Message")
        .message(responseData)
        .url("payment")
        .sendIt(1);
}

const getFailedAuthMessage = (responseData) => {

    try {
        void reportUnrecognisedPaymentMessage(responseData);
    } catch (e) {}

    if(responseData.paresStatus === "R" && responseData.veresEnrolled === "Y") {
        return "A problem has occurred. We cannot accept this payment, please try another form of payment. "
    }

    return "Card authentication failed. Please check all card details are correct.";
}

const runStep = async (session, step, payload) => {

    const req = request.process(api.PROCESS.PAYMENT_HANDLER)
        .paramObject("payload", payload)
        .param("step",step);
    const url = env.API_URL + req.buildRequest();
    const resp = await HttpClient.client.post(url, req.buildRequestBody(), api.auth(session));

    const data = idempiereProcess.handleResponseThrowingException(resp);
    const summary = data.summary;
    const errorID = "ApiError:";

    if(summary.startsWith(errorID)) {
        return {apiError: summary.slice(errorID.length)}
    } else if(summary === "orderHasPayment") {
        return {success: true};
    } else {
        const responseData = JSON.parse(data.summary);
        if(responseData.status && responseData.status === "AUTHENTICATION_FAILED") {
            return { apiError: getFailedAuthMessage(responseData) }
        } else {
            return responseData;
        }
    }
}

export const step1 = createAsyncThunk(
    'payment/step1',
    async ({session, details}, {dispatch, rejectWithValue}) => {

        try {
            return await runAuthRequest(session, s => runStep(s, "step1", details), dispatch);

        } catch (error) {
            return api.catchError(dispatch, rejectWithValue, error, session)
        }
    }
)

const formatStep3Data = (data) => {
    const isMobile = Platform.isMobile();
    if(!isMobile) {
        return {
            ...data,
            returnUrl: URL_RETURN
        }
    } else {
        return {
            ...data,
            returnProtocol: "http",
            returnHost: "localhost:8557",
            returnLink: "redirect"
        }
    }
}

export const step3 = createAsyncThunk(
    'payment/step3',
    async ({session, details}, {dispatch, rejectWithValue}) => {

        try {
            const data = formatStep3Data(details);
            return await runAuthRequest(session, s => runStep(s, "step3", data), dispatch);

        } catch (error) {
            return api.catchError(dispatch, rejectWithValue, error, session)
        }
    }
)

export const step5 = createAsyncThunk(
    'payment/step5',
    async ({session, details}, {rejectWithValue, dispatch}) => {

        try {
            return await runAuthRequest(session, s => runStep(s, "step5", details), dispatch);
        } catch (error) {
            return api.catchError(dispatch, rejectWithValue, error, session)
        }
    }
)
